import { FONT_FAMILY } from '@web/styles/typography'

const themeStyles = colors => {
  const styles = {
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: 0,
      marginBottom: '1em'
    },
    testContainer: {
      display: 'flex',
      margin: 0,
      padding: '10px 20px',
      backgroundColor: colors.lighterSmoke
    },
    titleContainer: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    title: {
      color: colors.darkDesaturatedBlue,
      flexBasis: 'auto',
      marginRight: '2rem'
    },
    learnMoreButton: {
      whiteSpace: 'nowrap',
      display: ''
    },
    text: {
      color: colors.primary,
      flexBasis: 'auto',
      margin: 0
    },
    textMiddle: isMobile => {
      return {
        flexBasis: 'auto',
        width: '100%',
        flex: isMobile ? 1 : 'none',
        padding: 10,
        margin: 0
      }
    },
    textRight: isMobile => {
      return {
        flexBasis: 'auto',
        width: isMobile ? 'auto' : '20%',
        padding: 10,
        margin: 0
      }
    },
    pastText: {
      flexBasis: 'auto',
      margin: 0,
      minWidth: '54px',
      width: '100px'
    },
    groupsTitles: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '15px'
    },
    tabContainer: {
      display: 'flex',
      justifyContent: 'center',
      boxSizing: 'borderBox',
      cursor: 'pointer',
      width: '100px'
    },
    activeTabTitle: {
      fontWeight: 700,
      fontSize: '14',
      lineHeight: '14px'
    },
    groupContentContainer: {
      position: 'relative'
    },
    separator: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '3px',
      backgroundColor: colors.placebo
    },
    detailsBorder: {
      position: 'absolute',
      width: '100px',
      height: '3px',
      backgroundColor: colors.primary
    },
    pastGroupContentTitles: {
      display: 'flex',
      alignItems: 'center'
    },
    groupContentTitles: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 20
    },
    componentContainer: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    generalInformationTitle: {
      padding: '8px 0'
    },
    groupsContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    generalText: {
      fontSize: '14',
      color: colors.approxBlack,
      lineHeight: '20px',
      marginBottom: 0
    },
    pastTestTitleContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: 200
    },
    autoWidth: {
      width: 'auto'
    },
    marginSmall: {
      margin: '5px  0'
    },
    marginBig: {
      margin: '15px 0 0 0'
    },
    maxWidth: {
      flex: 1
    },
    pastResultsLine: {
      display: 'flex',
      flexWrap: 'nowrap'
    },
    noResults: {
      color: colors.approxBlack
    },
    textContainer: {
      marginTop: 10
    },
    barChartAre: isMobile => {
      return {
        position: 'relative',
        width: !isMobile && '60%'
      }
    },
    expandableCard: {
      width: '100%',
      minHeight: '1.5em',
      borderRadius: 5,
      border: 'none',
      fontFamily: FONT_FAMILY,
      background: colors.white
    },
    calendarCard: {
      fontFamily: FONT_FAMILY,
      textAlign: 'center',
      background: colors.snowflake,
      userSelect: 'none',
      color: colors.approxBlack,
      fontWeight: 700,
      borderRadius: 5,
      width: '6em',
      height: '6em',
      padding: '0.5em'
    },
    mobileCalendarCard: {
      fontFamily: FONT_FAMILY,
      textAlign: 'center',
      background: colors.snowflake,
      userSelect: 'none',
      color: colors.approxBlack,
      fontWeight: 700,
      borderRadius: 5,
      margin: '0 -5px',
      padding: '5px 0px'
    },
    year: {
      weight: 400,
      size: 12
    },
    month: {
      fontSize: 12
    },
    day: {
      fontSize: 32,
      lineHeight: '32px',
      fontWeight: 700
    },
    monthMobile: {
      textAlign: 'center',
      fontSize: 14,
      fontWeight: 700
    },
    dayMobile: {
      textAlign: 'center',
      fontSize: 28,
      fontWeight: 700
    },
    yearMobile: {
      weight: 400,
      size: 12,
      textAlign: 'center'
    },
    button: {
      display: 'flex',
      flex: '0.1',
      marginLeft: 'auto'
    },
    expandButton: {
      background: colors.white,
      color: colors.primary,
      fontSize: '1.5em',
      padding: 0
    },
    expandButtonMobile: {
      background: colors.white,
      color: colors.primary,
      height: '100%',
      maxHeight: 135,
      fontSize: 20,
      position: 'absolute',
      zIndex: 100,
      top: 0,
      right: 0
    },
    listTitle: {
      fontWeight: 700,
      fontSize: 16,
      marginBottom: 5,
      marginTop: 5
    },
    listSubTitle: {
      fontWeight: 400,
      fontSize: 12
    },
    providerContainer: isMobile => ({
      flex: isMobile ? 8 : 15
    }),
    cardRow: isMobile => ({ gap: isMobile ? '0rem' : '0rem' }),
    calendarCardContainer: isMobile => ({
      flex: '0.1',
      marginRight: isMobile ? '5em' : '3em'
    }),
    loadingContainer: {
      minHeight: '2em',
      alignContent: 'center',
      fontSize: '1.5em'
    }
  }
  styles.clickableText = {
    ...styles.text,
    cursor: 'pointer',
    spanText: {
      fontWeight: 700,
      color: colors.primary
    }
  }
  styles.inactiveTabTitle = { ...styles.activeTabTitle, fontWeight: 400 }
  styles.pastBorder = { ...styles.detailsBorder, left: '100px' }
  styles.wideTitle = { ...styles.text, minWidth: 200, width: 200 }
  styles.wideText = { ...styles.text, width: 200 }
  return styles
}

export default themeStyles
